import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'institutionId',
                  },
                ],
              },
              modelId: 'ent:!ext_institutions:!institution',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
